import React from "react"
import ReactDOM from "react-dom/client"
import 'photoswipe/dist/photoswipe.css'
import App from "./App.tsx"
import CssBaseline from '@mui/material/CssBaseline';

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
)
